import { configureStore } from '@reduxjs/toolkit';
import { rtkApi } from '../api_service/rtkApi';
import authGateReducer from './features/auth_gate_reducer';
import AuthPermissionsReducer from './features/auth_permissions_reducer';
import jobTitleReducer from './features/job_title_reducer';
import skillLevelReducer from './features/level_reducer';
import logoReducer from './features/logo_reducer';
import organizationUserReducer from './features/organization_user_reducer';
import questionReducer from './features/question_reducer';
import rolesReducer from './features/roles_reducer';
import skillsReducer from './features/skill_reducer';
import subscriptionReducer from './features/subscription_reducer';
import subSkillsReducer from './features/subskill_reducer';
import userGroupReducer from './features/user_group_reducer';
import userRoleReducer from './features/user_role_reducer';
import viewReducer from './features/ViewReducer';

export const store = configureStore({
  reducer: {
    [rtkApi.reducerPath]: rtkApi.reducer,
    questions: questionReducer,
    skills: skillsReducer,
    skillLevels: skillLevelReducer,
    roles: rolesReducer,
    subSkills: subSkillsReducer,
    userRoles: userRoleReducer,
    userGroups: userGroupReducer,
    organizationUsers: organizationUserReducer,
    permissions: AuthPermissionsReducer,
    authGate: authGateReducer,
    jobTitles: jobTitleReducer,
    subscriptions: subscriptionReducer,
    view: viewReducer,
    logo: logoReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(rtkApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
